import React, { Component } from "react";
import { Link } from "react-router-dom";
import { socialWebTalk } from "./homeImages";
import ScrollToButton from '../../components/buttons/ScrollToButton';
import EnrollingComponent from '../../components/enrolling-component/enrolling-component';


class SocialInWebtalk extends Component{

	constructor(props){
		super(props);
		this.state={

		}
	}

	render() {
		return (
			<section className="social-in-webtalk">
				   <div className="social-in-webtalk-wrap animate-fade">
				      <div className="social-content">
				         <h2>Get paid to be social in Webtalk</h2>
				         <p>Enrollment is fast and free</p>
				         <ScrollToButton/>
				         <EnrollingComponent/>
				      </div>
				      <div className="more-content-block ">
				         <div className="content-block content-block-1 slidedown-anim">
				            <div className="img">
				               <img src={socialWebTalk.earn_your_time.url} alt={"Earn from your time and content"}/>
				            </div>
				            <span>Earn from your time and content</span>
				            <p>We place top quality high paying ads on the content you consume and share in Webtalk, which awards you points for all ad views you help create. These points redeem for cash every month. </p>
				         </div>
				         <div className="like-share-comment-wrap" style={{backgroundImage: `url(images/like-share-bg.png)`}}>
				            <div className="like-share-comment-block left-right-anim" >
				               <div className="border-section"></div>
				               <div className="link-section flex">
				                  <Link to={""} title="">
				                  <img src={socialWebTalk.likes.url} alt={"Like"} />Like</Link>
				                  <Link to={""} title="">
				                  <img src={socialWebTalk.comments.url} alt={"Comment"} />Comment</Link>
				                  <Link to={""} title="">
				                  <img src={socialWebTalk.share.url} alt={"Share"} />Share</Link>
				               </div>
				            </div>
				         </div>
				         <div className="flex">
				            <div className="content-block content-block-2 slideup-anim">
				               <div className="img">
				                  <img src={socialWebTalk.save_time_money.url} alt={"Earn from your time and content"}/>
				               </div>
				               <span>Save time and money</span>
				               <p>When you share content on Webtalk you can also syndicate it to Facebook, LinkedIn, Twitter, and more - all with no cost. </p>
				            </div>
				            <div className="content-block content-block-3 right-left-anim">
				               <div className="img">
				                  <img src={socialWebTalk.earnings_1.url} alt={"Content consumers earn too"}/>
				               </div>
				               <span>Content consumers earn too</span>
				               <p>Get paid to read news, visit profiles, and simply manage your Webtalk account. Every page and post with ads pays you up to 10% of the ad revenue you helped generate.</p>
				            </div>
				         </div>
				      </div>
				   </div>
			</section>		
			);
	}

};

export default SocialInWebtalk;				